import React from 'react';


const ScientistHatSVG = () => {
  return (
    <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 9.5V14.259C19 15.3356 18.4231 16.3296 17.4884 16.8638L14.9768 18.299C13.1322 19.353 10.8678 19.353 9.02317 18.299L6.51158 16.8638C5.57686 16.3296 5 15.3356 5 14.259V9.5M1 7L12 1L23 7L12 13L1 7Z" stroke="#F3A60D" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default ScientistHatSVG;
